export const API_CONNECTED_USERS_REQUEST = 'API_CONNECTED_USERS_REQUEST';
export const API_CONNECTED_USERS_SUCCESS = 'API_CONNECTED_USERS_SUCCESS';
export const API_CONNECTED_USERS_FAILURE = 'API_CONNECTED_USERS_FAILURE';
export const SELECT_RECIPIENT = 'SELECT_RECIPIENT';

export const selectRecipient = payload => ({
  type: SELECT_RECIPIENT,
  payload,
});

export const connectedUsersRequest = () => ({
  type: API_CONNECTED_USERS_REQUEST,
});

export const connectedUsersSuccess = payload => ({
  type: API_CONNECTED_USERS_SUCCESS,
  payload,
});

export const connectedUsersFailure = payload => ({
  type: API_CONNECTED_USERS_FAILURE,
  payload,
});

const initialState = {
  recipient: null,
  isFetched: false,
  fetching: false,
  error: null,
  users: [],
};

export function connectedUsersReducer(state = initialState, action) {
  switch (action.type) {
    case SELECT_RECIPIENT:
      return {
        ...state,
        recipient: action.payload,
      };
    case API_CONNECTED_USERS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_CONNECTED_USERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        isFetched: true,
        users: [...action.payload],
      };
    case API_CONNECTED_USERS_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
        users: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/connectedUsers.js